import React from 'react';

const SVG = ({
  style = {},
  fill = '#3c3c3c', 
  viewBox = '0 0 18 18',
  width = '100%',
  className = '',
  height = '100%',
  ...rest
}) => (
  <svg
    width={width}
    style={style}
    height={height}
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    viewBox={viewBox}
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...rest}
  >   
    <defs>
        <clipPath id="download-icon-clip-path">
            <path d="M0 0H18V18H0z" />
        </clipPath> 
    </defs>
    <g clip-path="url(#download-icon-clip-path)" fill={fill}> 
        <path d="M16.56 68.7v4.176H1.44V68.7H0v5.616h18V68.7z" transform="translate(0 -56.316)"/>
        <path d="M11.214 5.6L5.6 0 0 5.6l1.026 1.024 3.852-3.87V13.86h1.44V2.754l3.87 3.87z" transform="rotate(180 7.326 6.93)"/>
    </g> 
  </svg>
);
export default SVG;